import { render, staticRenderFns } from "./comparable_products.vue?vue&type=template&id=79bb129d&"
import script from "./comparable_products.vue?vue&type=script&lang=ts&"
export * from "./comparable_products.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports